import { render, staticRenderFns } from "./CircleWave.vue?vue&type=template&id=05416750&scoped=true&"
import script from "./CircleWave.vue?vue&type=script&lang=js&"
export * from "./CircleWave.vue?vue&type=script&lang=js&"
import style0 from "./CircleWave.vue?vue&type=style&index=0&id=05416750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05416750",
  null
  
)

export default component.exports